/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars, eqeqeq, no-lone-blocks */
import { useCallback } from 'react';

export const useSwimlaneLabelChange = ({
  setChiledNodes,
  setHasUnsavedChanges,
  processLangRef,
  langMapRef,
  isInitialLoad,
}) => {
  const handleLabelChange = useCallback(
    (nodeId, newLabel) => {
      setChiledNodes((nds) =>
        nds.map((node) => {
          if (
            node.id === nodeId ||
            node.node_id === nodeId ||
            String(node.id) === String(nodeId) ||
            String(node.node_id) === String(nodeId)
          ) {
            const currentLangId = processLangRef.current;
            const langKey = langMapRef.current[Number(currentLangId)] || 'EN';

            return {
              ...node,
              data: {
                ...node.data,
                ...(node.type === 'StickyNote'
                  ? {
                      label: newLabel,
                      translations: {
                        ...(node.data?.translations || {}),
                        [langKey]: newLabel,
                      },
                    }
                  : {
                      label: newLabel,
                      details: {
                        ...node.data?.details,
                        title: newLabel,
                      },
                      translations: {
                        ...(node.data?.translations || {}),
                        [langKey]: newLabel,
                      },
                    }),
              },
            };
          }
          return node;
        })
      );

      if (!isInitialLoad.current) {
        setHasUnsavedChanges(true);
      }
    },
    [setChiledNodes, setHasUnsavedChanges]
  );

  return { handleLabelChange };
};
